namespace $.$$ {

	export class $shm_hitalama_settings_agent extends $.$shm_hitalama_settings_agent {

		private adding_id = ''

		config_dictionary() {
			return Object.fromEntries(
				this.$.$shm_hitalama_settings.agent_configs().map( config => [ config.id, config.name ] ),
			)
		}

		current( next?: string ) {
			return this.$.$shm_hitalama_settings.agent_config_current( next )
		}

		spreads() {
			return Object.fromEntries( this.$.$shm_hitalama_settings.agent_configs().map( config => [ config.id, this.Config( config.id ) ] ) )
		}

		config( id: string ) {
			return this.$.$shm_hitalama_settings.agent_config( id )
		}

		config_name( id: string, next?: string ) {
			if( next !== undefined ) return this.$.$shm_hitalama_settings.agent_config( id, { name: next } ).name
			return this.config( id ).name
		}

		backend_dictionary() {
			return $shm_hitalama_agent_provider.titles()
		}

		config_backend( id: string, next?: string ) {
			if( next !== undefined ) {
				const backend = $shm_hitalama_agent_provider.normalize( next )
				return this.$.$shm_hitalama_settings.agent_config( id, { backend } ).backend
			}
			return this.config( id ).backend
		}

		config_url( id: string, next?: string ) {
			return this.$.$shm_hitalama_settings.agent_config_url( id, next )
		}

		connection_dictionary() {
			return { local: 'Локально', remote: 'По заданным адресам' }
		}

		config_connection( id: string, next?: string ) {
			const mode = this.$.$shm_hitalama_settings.agent_connection( id, next )
			if( next !== undefined ) {
				this.check_status( id, '' )
				this.check_status_kind( id, '' )
			}
			return mode
		}

		connection_hint( id: string ) {
			return this.config_connection( id ) === 'local'
				? 'Агент и MCP подключаются напрямую. 127.0.0.1 — это устройство; для другого компьютера в сети укажите его адрес. При недоступности переключитесь на внешний адрес вручную. Выбор сохраняется только в этом браузере.'
				: 'Используются сохранённые адреса агента и MCP, например внешние адреса туннеля. Для прямого подключения выберите «Локально». Выбор сохраняется только в этом браузере.'
		}

		url_label( id: string ) {
			return this.config_connection( id ) === 'local' ? 'Локальный URL ИИ-агента' : 'URL ИИ-агента'
		}

		mcp_url_label( id: string ) {
			return this.config_connection( id ) === 'local' ? 'Локальный URL Hitalama MCP' : 'URL Hitalama MCP'
		}

		mcp_url_hint( id: string ) {
			return this.config_connection( id ) === 'local' ? 'ws://127.0.0.1:4817/hitalama-mcp' : 'wss://example.com/hitalama-mcp'
		}

		config_token( id: string, next?: string ) {
			if( next !== undefined ) return this.$.$shm_hitalama_settings.agent_config( id, { token: next } ).token
			return this.config( id ).token
		}

		config_mcp_url( id: string, next?: string ) {
			return this.$.$shm_hitalama_settings.agent_config_mcp_url( id, next )
		}

		config_field_rows( id: string ) {
			return [
				this.Name_label( id ),
				this.Backend_label( id ),
				this.Connection_label( id ),
				this.Connection_hint( id ),
				this.Url_label( id ),
				this.Token_label( id ),
				...( $shm_hitalama_agent_provider.info( this.config( id ).backend ).mcp_configurable
					? [ this.Mcp_url_label( id ), this.Mcp_token_label( id ) ]
					: [] ),
				this.Check_row( id ),
			]
		}

		name_input_name( id: string ) {
			return `hitalama_agent_name_${ id }`
		}

		url_input_name( id: string ) {
			return `hitalama_agent_endpoint_${ id }`
		}

		token_input_name( id: string ) {
			return `hitalama_agent_secret_${ id }`
		}

		mcp_url_input_name( id: string ) {
			return `hitalama_agent_mcp_${ id }`
		}

		config_mcp_token( id: string, next?: string ) {
			if( next !== undefined ) return this.$.$shm_hitalama_settings.agent_config( id, { mcp_token: next } ).mcp_token ?? ''
			return this.config( id ).mcp_token ?? ''
		}

		mcp_token_input_name( id: string ) {
			return `hitalama_agent_mcp_secret_${ id }`
		}

		remove_visible( id: string ) {
			return this.$.$shm_hitalama_settings.agent_configs().length > 1
				? [ this.Remove( id ) ]
				: []
		}

		@ $mol_mem_key
		check_status( id: string, next?: string ) {
			return next ?? ''
		}

		@ $mol_mem_key
		check_status_kind( id: string, next?: string ) {
			return next ?? ''
		}

		check_enabled( id: string ) {
			return this.check_status_kind( id ) !== 'pending'
		}

		check_status_hidden( id: string ) {
			return !this.check_status( id )
		}

		@ $mol_action
		check( id: string, next?: Event ) {
			if( next === undefined ) return null
			const target = this.check_target( id )
			this.check_status_kind( id, 'pending' )
			this.check_status( id, 'Проверяем соединение…' )
			$mol_wire_async( this ).check_later( id ).catch( error => {
				if( this.check_target( id ) !== target ) return
				this.check_status_kind( id, 'error' )
				this.check_status( id, this.check_error_message( error ) )
			} )
			return next
		}

		check_target( id: string ) {
			const config = this.config( id )
			return JSON.stringify([ this.config_connection( id ), config.backend, this.config_url( id ), config.token ])
		}

		async check_later( id: string ) {
			const target = this.check_target( id )
			const config = this.config( id )
			const url = this.config_url( id ).trim().replace( /\/$/, '' )
			if( !url ) throw new Error( 'URL не задан' )
			if( !config.token.trim() ) throw new Error( 'Токен не задан' )

			const provider = $shm_hitalama_agent_provider.info( config.backend )
			const response = await fetch( url + provider.health_path, {
				headers: $shm_hitalama_agent_provider.health_headers( config.backend, config.token.trim() ),
			} )
			if( !response.ok ) throw new Error( `HTTP ${ response.status }` )
			const health = await response.json() as any
			if( this.check_target( id ) !== target ) return

			const status = $shm_hitalama_agent_provider.health_message( config.backend, health )
			this.check_status_kind( id, status.ready ? 'success' : 'error' )
			this.check_status( id, status.message )
		}

		check_error_message( error: unknown ) {
			const message = error instanceof Error ? error.message : String( error )
			if( /HTTP 401/.test( message ) ) return 'Неверный токен'
			if( /HTTP 502/.test( message ) ) return 'Мост или рантайм недоступен'
			if( /URL не задан|Токен не задан/.test( message ) ) return message
			return 'Не удалось подключиться к серверу'
		}

		@ $mol_action
		add( next?: Event ) {
			if( next === undefined ) return null
			const configs = this.$.$shm_hitalama_settings.agent_configs()
			this.adding_id ||= `config-${ Date.now().toString( 36 ) }`
			const id = this.adding_id
			this.$.$shm_hitalama_settings.agent_config_add({
				id,
				name: `Конфигурация ${ configs.length + 1 }`,
				backend: 'opencode',
				url: '',
				token: '',
				mcp_url: '',
			})
			this.$.$shm_hitalama_settings.agent_config_current( id )
			this.spread( id )
			this.adding_id = ''
			return next
		}

		@ $mol_action
		remove( id: string, next?: Event ) {
			if( next === undefined ) return null
			this.$.$shm_hitalama_settings.agent_config_remove( id )
			if( this.spread() === id ) this.spread( '' )
			return next
		}

	}

}
